import { Box } from '@zoopla-eng/zds-components/box';
import { Link } from '@zoopla-eng/zds-components/link';
import { SeoLinkList } from '@zoopla/landing-pages/seo-link-list';
import { SeoLink, SeoLinkProps } from './cms-seo.types';
import { mapFromPictogramToIcon } from './helpers/iconMapper';

function CmsSeoLinks({
    title,
    seoLinks,
    seeMoreLinkText,
    seeMoreLinkHref
}: SeoLinkProps) {
    return (
        <div>
            <Box display="flex" justifyContent="space-between">
                <h2>{title}</h2>

                {seeMoreLinkText && seeMoreLinkHref && (
                    <Box
                        display="none"
                        bpL100={{
                            display: 'block'
                        }}
                    >
                        <Link href={seeMoreLinkHref}>{seeMoreLinkText}</Link>
                    </Box>
                )}
            </Box>

            {seoLinks.map((seoLink: SeoLink, i: number) => (
                <SeoLinkList
                    key={`seolink-${i}`}
                    text={seoLink.subtitle}
                    heading={seoLink.title}
                    icon={mapFromPictogramToIcon(seoLink.pictogram)}
                    links={seoLink.links}
                />
            ))}
        </div>
    );
}

export default CmsSeoLinks;
